import {Component, OnInit, ViewChild} from '@angular/core';
import {NgForm} from '@angular/forms';
import {ApiClientService} from '../../../../services/api-client.service';
import {UserService} from '../services/user.service';
import {ConstantsService} from '../../../../services/constants.service';
import {DirectoryService} from '../../../../services/directory.service';
import {UrlService} from '../../../../services/url.service';
import {Observable} from 'rxjs/Observable';

declare const toastr: any;
declare const swal: any;

@Component({
    selector: 'delete-user-modal',
    templateUrl: './delete-user-modal.component.html',
    styleUrls: ['./delete-user-modal.component.scss']
})
export class DeleteUserModalComponent implements OnInit {
    @ViewChild('form') form;
    showModal = false;
    disabledSubmit = false;
    buildingSelectIsDisabled = false;
    allUsersList = [];
    usersList = [];
    suites = [];
    buildingsWithUsers = [];
    building = null;

    constructor(
        public api: ApiClientService,
        public userService: UserService,
        public urlService: UrlService,
        public directoryService: DirectoryService
    ) {}

    ngOnInit() {
        this.allUsersList = JSON.parse(JSON.stringify(this.userService.userInResetPasswordModal.suiteUsers));
        this.buildingsWithUsers = this.userService.buildings.filter(b => this.allUsersList.find(u => u.buildingId == b.id));
        this.building = this.buildingsWithUsers[0].id;
        this.changeBuilding(this.building);
        setTimeout( () => this.showModal = true, 300);
        this.urlService.modalOpened.emit();
    }

    hideModal() {
        if (this.form.dirty && this.form.touched) {
            swal(ConstantsService.getSwalConfig('Close without saving?', 'Do you want to delete unsaved data?'),
                () => {
                this.userService.isShowDeletePopup = false;
                this.userService.userInResetPasswordModal = null;
                this.urlService.modalClosed.emit();
            });
        } else {
            this.userService.isShowDeletePopup = false;
            this.userService.userInResetPasswordModal = null;
            this.urlService.modalClosed.emit();
        }
    }

    onSubmit(form: NgForm) {
        if (this.usersList.filter(u => u.checked).length < 1) {
            toastr.warning('At least one user must be chosen to proceed');
            return;
        }

        this.disabledSubmit = true;

        const observables = [];
        this.usersList.forEach(u => {
            if(u.checked) {
                const url = `/api/suite_user/${u.id}`;
                observables.push(this.api.remove('oauthUrl', url));
            }
        });
        Observable.forkJoin(observables).subscribe(
            () => this.updateView('Users have been deleted successfully'),
            error => {
                this.disabledSubmit = false;
                this.api.errorHandler(error, 'Failed to delete some of the selected users');
            }
        );
    }

    updateView(msg: string): void {
        toastr.success(msg);
        this.userService.get();
        this.form.reset();
        this.hideModal();
    }

    changeBuilding(value) {
        this.filterBuildings(value);
        if(this.usersList.length > 0)
            this.getSuites(value);
    }

    getSuites(buildingId: number): void {
        if (!buildingId) return;
        const url = `/v1/suite/select.json?per-page=1000&order-by=suiteNumber|asc&building_id=${buildingId}`;
        this.buildingSelectIsDisabled = true;
        this.api.get('domainBD', url).subscribe(
            res => {
                this.suites = JSON.parse(res._body).entities || [];
                this.usersList.forEach(u => {
                    const suite = this.suites.find(s => u.suiteId == s.id);
                    if(suite)
                        u.suiteNumber = suite.suiteNumber;
                });
            },
            error => this.api.errorHandler(error, 'Failed get suites'),
            () => this.buildingSelectIsDisabled = false
        );
    }

    filterBuildings(id) {
        this.usersList = this.allUsersList.filter(u => u.buildingId == id);
    }
}



// WEBPACK FOOTER //
// /app/src/app/views/admin/user/delete-user-modal/delete-user-modal.component.ts